/**
	An identity function
	@type {*} d The value to return.
	@returns {*}
*/
export default function identity (d) {
	return d;
}
